import React from 'react';
import GenericDialog from '@common/GenericDialog';

const PrintTestDialog = ({
                             open,
                             onClose,
                             onPrintTest,
                             selectedSingleTest,
                         }) => {
    return (
        <GenericDialog
            title={`Print: ${selectedSingleTest?.name} diagnostic`}
            open={open}
            onClose={onClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Print',
                    callback: onPrintTest,
                },
            ]}
        >
            <p>Are you sure you want to print “{selectedSingleTest?.name}”?</p>
        </GenericDialog>
    );
};

export default PrintTestDialog;
